/**
 * WizardStepPreview - Passo 3: Preview do contrato com variáveis preenchidas
 * Reutiliza o ContractTemplatePreview para paridade visual com editor e PDF
 * 
 * RELEASE: v2.0.0 - 2026-02-16 - Migrado para ContractTemplatePreview
 * RELEASE: v1.0.0 - 2026-02-16 - Versão inicial
 */
import { ContractTemplatePreview } from '@/components/contracts/ContractTemplatePreview';

/** Props do componente de preview no wizard */
interface WizardStepPreviewProps {
  /** HTML do contrato com variáveis já substituídas */
  html: string;
  /** URL assinada da imagem de fundo do template */
  backgroundPreviewUrl?: string | null;
  /** Se exibe número de página */
  showPageNumbers?: boolean;
  /** Posição da paginação: 'top-right' ou 'bottom-right' */
  pageNumberPosition?: string;
  /** Margem superior em mm quando há plano de fundo (padrão: constante do contractStyles) */
  bgMarginTopMm?: number;
  /** Margem inferior em mm quando há plano de fundo (padrão: constante do contractStyles) */
  bgMarginBottomMm?: number;
  /** Offset vertical em mm da borda para a paginação (padrão: 12mm) */
  paginationYOffsetMm?: number;
}

export function WizardStepPreview({
  html,
  backgroundPreviewUrl,
  showPageNumbers,
  pageNumberPosition,
  bgMarginTopMm,
  bgMarginBottomMm,
  paginationYOffsetMm,
}: WizardStepPreviewProps) {
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        Visualize como o contrato ficará com as variáveis preenchidas.
      </p>

      <ContractTemplatePreview
        contentHtml={html}
        backgroundPreviewUrl={backgroundPreviewUrl}
        showPageNumbers={showPageNumbers}
        pageNumberPosition={pageNumberPosition}
        bgMarginTopMm={bgMarginTopMm}
        bgMarginBottomMm={bgMarginBottomMm}
        paginationYOffsetMm={paginationYOffsetMm}
      />
    </div>
  );
}
